const industries = [
  {
    icon: 'ri-flask-line',
    title: 'Pharmaceutique',
    desc: 'IPA, excipients, formes posologiques finies et services de développement — approvisionnés auprès de fabricants audités et conformes dans le monde entier.',
    tags: ['IPA', 'Excipients', 'Formes finies', 'Certifié BPF'],
    image: 'https://public.readdy.ai/ai/img_res/5fc0ae4222fcf5261ca0c6314a7c6088.jpg',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Alimentaire',
    desc: 'Ingrédients, additifs et composants alimentaires spéciaux approvisionnés avec traçabilité complète et conformité réglementaire pour tpout les marchés.',
    tags: ['Ingrédients', 'Additifs', 'HACCP', 'Traçabilité'],
    image: 'https://readdy.ai/api/search-image?query=modern%20food%20processing%20facility%20with%20stainless%20steel%20production%20lines%20conveyor%20belts%20and%20food%20grade%20equipment%20bright%20clean%20industrial%20setting%20with%20warm%20natural%20tones%20professional%20food%20manufacturing%20plant&width=600&height=400&seq=industry-food-001&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Industriel',
    desc: 'Produits chimiques spéciaux, matières premières et intrants industriels consolidés et livrés par un seul partenaire d&apos;approvisionnement de confiance.',
    tags: ['Chimiques spéciaux', 'Matières premières', 'Approvisionnement consolidé'],
    image: 'https://readdy.ai/api/search-image?query=large%20industrial%20manufacturing%20plant%20with%20heavy%20machinery%20production%20equipment%20and%20workers%20in%20safety%20gear%20warm%20amber%20and%20steel%20tones%20professional%20industrial%20facility%20with%20pipes%20and%20processing%20equipment&width=600&height=400&seq=industry-industrial-001&orientation=landscape',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Minier',
    desc: "Réactifs, produits chimiques de traitement et consommables pour les opérations minières — approvisionnés de manière fiable, consolidés et gérés dans les chaînes d'approvisionnement mondiales.",
    tags: ['Réactifs', 'Chimiques de traitement', 'Consommables'],
    image: 'https://readdy.ai/api/search-image?query=open%20pit%20mining%20operation%20with%20large%20excavators%20and%20haul%20trucks%20at%20golden%20hour%20warm%20earthy%20tones%20dramatic%20landscape%20with%20mining%20equipment%20and%20processing%20facilities%20in%20background%20professional%20industrial%20photography&width=600&height=400&seq=industry-mining-001&orientation=landscape',
  },
];

export default function IndustriesSectionFr() {
  return (
    <section className="w-full px-6 md:px-16 py-20 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <span className="text-emerald-700 text-xs font-bold uppercase tracking-widest block mb-3">
            Secteurs desservis
          </span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-900 leading-tight"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Les secteurs que nous servons
          </h2>
          <p className="text-stone-500 text-base mt-3 max-w-2xl leading-relaxed">
            Des chaînes d&apos;approvisionnement pharmaceutiques réglementées à l&apos;industrie lourde et à la production alimentaire — MAX-Sourcing offre des solutions d&apos;approvisionnement qualifiées et conformes dans les secteurs clés.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map(({ icon, title, desc, tags, image }) => (
            <div
              key={title}
              className="group rounded-lg border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5 bg-stone-50">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-100">
                    <i className={`${icon} text-emerald-700 text-sm`} />
                  </div>
                  <h4
                    className="text-base font-extrabold text-stone-900"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {title}
                  </h4>
                </div>
                <p className="text-xs text-stone-500 leading-relaxed mb-4 flex-1">{desc}</p>
                <div className="flex flex-wrap gap-1.5">
                  {tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs font-semibold bg-white border border-stone-200 text-stone-600 px-2 py-0.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
